import RestoreOrganizationWorkflow from '@Application/Organizations/Workflows/Commands/RestoreOrganizationWorkflow';
import restoreOrganizationWorkflow from '@Application/Organizations/Workflows/restoreOrganizationWorkflow';
import { PermissionEnum } from '@Application/Security/Roles';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import useHasPermission from '@UI/Providers/PermissionProvider/useHasPermission';
import * as React from 'react';
import { useDispatch } from '@verclam/synapse';
import { Button } from '@verclam/ui-kit';

type Props = {
	readonly organizationId: number;
	readonly workflowKey: string;
};

/** Leaf action: reactivating is not destructive, so it is dispatched at once, without a dialog. */
const RestoreDocumentGroupAction: React.FC<Props> = ({ organizationId, workflowKey }) => {
	const dispatch = useDispatch();
	const canWrite = useHasPermission(PermissionEnum.ORGANIZATION_WRITE);
	const [isRestoring, setIsRestoring] = React.useState(false);

	const handleRestoreClick = React.useCallback(() => {
		setIsRestoring(true);
		dispatch(restoreOrganizationWorkflow(new RestoreOrganizationWorkflow(organizationId, workflowKey)))
			.catch(ignoreHandledError)
			.finally(() => setIsRestoring(false));
	}, [dispatch, organizationId, workflowKey]);

	if (!canWrite) {
		return null;
	}

	return (
		<Button
			type="button"
			severity="secondary"
			label="Réactiver le groupe"
			loading={isRestoring}
			onClick={handleRestoreClick}
		/>
	);
};

export default RestoreDocumentGroupAction;
